import { createContext } from 'react';

interface IAuthContext {
  signIn: (formValues: { email: string; password: string }) => void;
  signOut: (options?: any) => void;
}

export const authContext = createContext<IAuthContext | null>(null);
